import React, {useState, useEffect, Fragment} from 'react';
import Button from '../Button/Button';
import InputCell, { dateValidate } from '../InputCell/InputCell'
import {
  Container,
  Row,
  Col,
  Form,
  FormText,
} from 'reactstrap';
import {useErrorToast} from '../../hooks/useErrorToast';
import {useFormValidation} from '../../hooks/useFormValidation';
import sof from '../../stacks/sourceOfFunds/sourceOfFundsAWS';

const clearForm = {
  userFirstName: '',
  userLastName: '',
  userEmail: '',
  userTextPhone: '',
  userUserId: '',
  userAddress1: '',
  userAddress2: '',
  userCity: '',
  userState: '',
  userZip: '',
}

// Double purpose to both add and modify a user

const SourceOfFundsUserScreen = props => {
  const {sofUserId} = props

  const [form,setForm] = useState(clearForm)
  const [isAdmin, setIsAdmin] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const {setErrorMsg,errorToast} = useErrorToast('');
  const {validated,setValidated,checkValidation} = useFormValidation(form,[
    'userFirstName',
    'userLastName',
    'userEmail',
    'userTextPhone',
    'userAddress1',
    'userCity',
    'userState',
    'userZip',
  ]);

  const controlled = {
    form,
    setForm,
    setIsDirty,
    validated
  }

  const sofAPI = sof.getInstance();

  useEffect(() => {
    const sofAPI = sof.getInstance();

    async function retrieve(sofUserId) {
      try {
        const data = await sofAPI.retrieveSofUser(sofUserId)

        setForm({...clearForm, ...data.user})
        setIsAdmin(data.isAdmin ? true: false)
      }
      catch(err) {
        setErrorMsg(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
        console.error(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
      }
    }
    if (sofUserId&& !props.add) {
      retrieve(sofUserId)
    }
  }, [sofUserId, props.add, setErrorMsg])

  async function store() {
    try {
      let isValid = checkValidation();
      setValidated(isValid);

      if (isValid) {
        if (form.userEmail[form.userEmail.length-1] === '*') {
          form.userEmail = form.userEmail.substring(0, form.userEmail.length-1)
        }
        await sofAPI.storeSofUser(sofUserId, form)
        props.setSofUserId('')
      }
    }
    catch(err) {
      setErrorMsg(`Store error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`Store error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  async function create() {
    try {
      let isValid = checkValidation();
      setValidated(isValid);

      if (isValid) {
        let user = {...form}
        if (user.userUserId === '') {
          user.userUserId = user.userEmail
        }
        if (user.userEmail[user.userEmail.length-1] === '*') {
          user.userEmail = user.userEmail.substring(0, user.userEmail.length-1)
        }
        await sofAPI.createSofUser(user)
        props.setSofUserId('')
      }
    }
    catch(err) {
      setErrorMsg(`Store error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`Store error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  return (
    <Fragment>
      <Container>
        {/* <Block> */}
          <Row>
            <Col>
              <FormText>* <i>required field</i> </FormText>
            </Col>
          </Row>
          <Row>
            <Col sm={11}>
              {sofUserId
                ? `${sofUserId}`
                : ``
              }
            </Col>
            <Col sm={1}>
              {isAdmin ? <strong>ADMIN</strong> : ''}
            </Col>
          </Row>
          <div style={{height:'40px'}} />
          <Form>
            <Row>
              {form.isAdmin && 
                <Col md={4}>
                  <strong>ADMIN</strong>
                </Col>
              }
            </Row>
            <Row form>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='First Name*'
                  name='userFirstName'
                  validate
                />
              </Col>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='Last Name*'
                  name='userLastName'
                  validate
                />
              </Col>
            </Row>
            <Row form>
              <Col md={4}>
                <InputCell
                  controlled={controlled}
                  label='Email*'
                  name='userEmail'
                  validate
                />
              </Col>
              {((form.userEmail.length > 0 && form.userEmail[form.userEmail.length-1] === '*')
              || (form.userUserId && form.userEmail !== form.userUserId)) &&
                <Col md={4}>
                  <InputCell
                    controlled={controlled}
                    label='UserId*'
                    name='userUserId'
                    validate
                  />
                </Col>
              }
              <Col md={4}>
                <InputCell
                  controlled={controlled}
                  label='Phone Number for text*'
                  name='userTextPhone'
                  validate
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputCell
                  controlled={controlled}
                  label='Address line 1*'
                  name='userAddress1'
                  validate
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputCell
                  controlled={controlled}
                  label='Address line 2'
                  name='userAddress2'
                />
              </Col>
            </Row>
            <Row form>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='City*'
                  name='userCity'
                  validate
                />
              </Col>
              <Col md={4}>
                <InputCell
                  controlled={controlled}
                  label='State*'
                  name='userState'
                  state
                  validate
                />
              </Col>
              <Col md={2}>
                <InputCell
                  controlled={controlled}
                  label='Zip*'
                  name='userZip'
                  validate
                />
              </Col>
            </Row>
            <Row>
            <hr style={{marginTop:'40px'}} />
            <div style={{textAlign:'right'}}>
              {!validated && <span style={{color: 'red', verticalAlign: 'center'}}>Please correct red outlined fields&nbsp;</span>}
              <Button click={() => {props.setSofUserId('')}}>CANCEL</Button>
              { isDirty && (props.add
              ? <Button click={create}>ADD</Button>
              : <Button click={store}>UPDATE</Button>
              )}
            </div>
            </Row>
          </Form>
        {/* </Block> */}
        <div style={{height:60}} />
      </Container>
      {errorToast}
    </Fragment>
  );
};

export default SourceOfFundsUserScreen;
